import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full order-2 lg:order-1">
            <div className="relative w-full aspect-[4/3] max-w-[560px] rounded-2xl overflow-hidden bg-background-50 border border-background-200/50">
              <img
                src={aboutInfo.image}
                alt="黑料官网平台介绍"
                title="黑料官网 - 泛娱乐内容聚合平台"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-background-50/30 via-transparent to-transparent" />
            </div>
          </div>

          <div className="flex-1 w-full order-1 lg:order-2">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-500/15 text-secondary-300 border border-secondary-500/20 mb-4">
              关于我们
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50 mb-6">
              {aboutInfo.title}
            </h2>
            <div className="space-y-4 mb-8">
              {aboutInfo.paragraphs.map((p, i) => (
                <p key={i} className="text-sm md:text-base text-foreground-400 leading-relaxed">
                  {p}
                </p>
              ))}
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {aboutInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center p-4 rounded-xl bg-background-50 border border-background-200/50">
                  <p className="font-heading text-xl md:text-2xl font-bold text-primary-400">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}